import { buildUrlWithSearchParams } from './shared';

let iframe: HTMLIFrameElement | null;

const MESSAGE_EVENT_TYPES = {
  QUOTE_REJECTED: 'QUOTE_REJECTED',
  QUOTE_RECEIVED: 'QUOTE_RECEIVED',
  QUOTE_ACCEPTED: 'QUOTE_ACCEPTED',
  CUSTOMER_AND_VEHICLE_INFO: 'CUSTOMER_AND_VEHICLE_INFO',
  PICKUP_INFO: 'PICKUP_INFO',
  DELIVERY_INFO: 'DELIVERY_INFO',
  PAYMENT_INFO: 'PAYMENT_INFO',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',
  NEW_QUOTE_AFTER_PAYMENT: 'NEW_QUOTE_AFTER_PAYMENT'
} as const;

function handleDomContentLoaded() {
  iframe = document.getElementById('pov-quote-component') as HTMLIFrameElement;

  if (!iframe) {
    console.error('Iframe not found');
    return;
  }

  const iframeSrc = iframe.getAttribute('src');

  if (!iframeSrc) {
    console.error('Iframe src not found');
    return;
  }

  // Extract the path from the original iframe src
  const iframeUrl = new URL(iframeSrc);
  let iframePath = iframeUrl.pathname;

  // Only use parent hash as fallback if iframe path is just '/'
  const parentHash = window.location.hash;
  if (iframePath === '/' && parentHash) {
    // Remove the '#' and add leading '/' if needed
    const hashPath = parentHash.startsWith('#')
      ? parentHash.slice(1)
      : parentHash;
    iframePath = hashPath.startsWith('/') ? hashPath : '/' + hashPath;
  }

  // Build the iframe URL preserving the original path
  const baseUrl = iframeUrl.origin + iframePath;
  const iframeUrlWithParams = buildUrlWithSearchParams(baseUrl);
  iframe.src = iframeUrlWithParams;

  console.log('iframe loaded with src', iframe.src);
}

function updateIframePath(url: string) {
  if (!iframe) {
    console.error('Iframe not found');
    return;
  }

  const currentIframeUrl = new URL(iframe.src);
  const baseUrl = currentIframeUrl.origin + url;
  const iframeUrlWithParams = buildUrlWithSearchParams(baseUrl);
  iframe.src = iframeUrlWithParams;
}

function updateWindowPath(url: string) {
  // Always use buildUrlWithSearchParams to ensure search params are preserved
  const destinationUrl = buildUrlWithSearchParams(url);
  window.location.replace(destinationUrl);
}

function handleMessage(event: MessageEvent) {
  if (!iframe) {
    console.error('Iframe not found');
    return;
  }

  const type = event.data.type;

  switch (type) {
    case MESSAGE_EVENT_TYPES.QUOTE_REJECTED: {
      updateIframePath('/');
      break;
    }
    case MESSAGE_EVENT_TYPES.QUOTE_RECEIVED:
      updateIframePath('/quote');
      break;
    case MESSAGE_EVENT_TYPES.QUOTE_ACCEPTED:
      updateWindowPath('/order-page/#customer-and-vehicle');
      break;

    case MESSAGE_EVENT_TYPES.CUSTOMER_AND_VEHICLE_INFO:
      updateWindowPath('/order-page/#pickup');
      updateIframePath('/pickup');
      break;
    case MESSAGE_EVENT_TYPES.PICKUP_INFO:
      updateWindowPath('/order-page/#delivery');
      updateIframePath('/delivery');
      break;
    case MESSAGE_EVENT_TYPES.DELIVERY_INFO:
      updateWindowPath('/order-page/#payment');
      updateIframePath('/payment');
      break;
    case MESSAGE_EVENT_TYPES.PAYMENT_SUCCESS:
      updateWindowPath('/order-page/#payment-success');
      updateIframePath('/payment-success');
      break;
    case MESSAGE_EVENT_TYPES.PAYMENT_FAILURE:
      updateWindowPath('/order-page/#payment-failure');
      updateIframePath('/payment-failure');
      break;
    case MESSAGE_EVENT_TYPES.NEW_QUOTE_AFTER_PAYMENT: {
      const parentOriginPathname = event.data.message.parentOriginPathname;
      updateWindowPath(parentOriginPathname);
      break;
    }
  }
}

document.addEventListener('DOMContentLoaded', handleDomContentLoaded);
window.addEventListener('message', handleMessage);
